import styled from 'styled-components';

import { FormBase, FormModal } from '@gbs-monorepo-packages/common';
import { scrollbar } from '@gbs-monorepo-packages/styles';

export const FormModalCustom = styled(FormModal)`
  overflow: unset;
  max-height: unset;
`;

export const Container = styled(FormBase.Content)`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: 75vh;
  padding-top: 0.25rem;
  margin-bottom: 0.25rem;

  ${scrollbar};
`;

export const ColorPickerContainer = styled.div`
  margin-top: 1rem;
`;

export const Title = styled.p`
  padding: 0.75rem 0 1.5rem;
  font-weight: bold;
`;
